<template>
    <!-- Footer -->
    <footer class="footer footer-nine">
        <!-- Footer Top -->
        <div class="footer-top aos" data-aos="fade-up">
            <div class="container">
                <div class="row">
                    <div class="col-xl-3 col-lg-4 col-md-12">
                        <!-- Footer Widget -->
                        <div class="footer-widget">
                            <div class="footer-logo">
                                <router-link to="/home/"><img src="@/assets/img/white-logo.svg" alt="logo" ></router-link>
                            </div>
                            <div>
                                <p>We ara a lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt</p>
                                <ul class="social-icon mb-0">
                                    <li>
                                        <a href="javascript:void(0);"><i class="fa-brands fa-google"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="fa-brands fa-facebook-f"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="fa-brands fa-linkedin-in"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="fa-brands fa-instagram"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="fa-brands fa-twitter"></i></a>
                                    </li>
                                    <li>
                                        <a href="javascript:void(0);"><i class="fa-brands fa-whatsapp"></i></a>
                                    </li>
                                </ul>
                            </div>
                            
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                    <div class="col-xl-6 col-lg-8 col-md-12">
                        <div class="row">
                            <div class="col-lg-4 col-md-4">
                                <div class="footer-widget">
                                    <h6 class="mb-3">Product</h6>
                                    <ul class="footer-menu">
                                        <li>
                                            <a href="javascript:void(0);">Account</a>
                                        </li>
                                        <li>
                                            <router-link to="/booking/booking">Book Appointment</router-link>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);">Orders</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);">Payments</a>
                                        </li>
                                        <li>
                                            <a href="javascript:void(0);">Returns</a>
                                        </li>
                                        <li>
                                            <router-link to="/pages/contact-us">Contact Us</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="footer-widget">
                                    <h6 class="mb-3">About</h6>
                                    <ul class="footer-menu">
                                        <li>
                                            <router-link to="/service-categories/categories">Categories</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/service/search">Services</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/pages/about-us">About us</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/pages/faq">FAQ</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/blogs/blog-list">Blog</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/pages/terms-condition">Terms</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div class="col-lg-4 col-md-4">
                                <div class="footer-widget">
                                    <h6 class="mb-3">Services</h6>
                                    <ul class="footer-menu">
                                        <li>
                                            <router-link to="/details/service-details">Car Wash</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/details/service-details">Beauty Saloon</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/details/service-details">Construction</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/details/service-details">Plumbing  service</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/details/service-details">Painting service</router-link>
                                        </li>
                                        <li>
                                            <router-link to="/details/service-details">Plumbing</router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-3 col-lg-6 col-md-12">
                        <!-- Footer Widget -->
                        <div class="footer-widget footer-contact">
                            <h6 class="mb-3">Contact</h6>
                            <div class="footer-contact-info">
                                <div class="footer-address">
                                    <span><i class="feather-phone-call"></i></span>
                                    <div>
                                        <h6>Phone Number</h6>
                                        <p>310-437-2766</p>
                                    </div>
                                </div>
                                <div class="footer-address">
                                    <span><i class="feather-mail"></i></span>
                                    <div>
                                        <h6>Mail Address</h6>
                                        <p>example@truelysell.com</p>
                                    </div>
                                </div>
                                <div class="footer-address">
                                    <span><i class="feather-map-pin"></i></span>
                                    <div>
                                        <h6>Address</h6>
                                        <p>706 Campfire Ave. Meriden, CT </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- /Footer Widget -->
                    </div>
                </div>
            </div>
        </div>
        <!-- /Footer Top -->

        <!-- Footer Bottom -->
        <div class="footer-bottom">
            <div class="container">
                <!-- Copyright -->
                <div class="copyright">
                    <div class="copyright-text text-center">
                        <p class="mb-0">
                            Copyright 2025 &copy; TruelySell. All rights reserved.
                        </p>
                    </div>
                </div>
                <!-- /Copyright -->
            </div>
        </div>
        <!-- /Footer Bottom -->
    </footer>
    <!-- /Footer -->
</template>